module.exports = __webpack_public_path__ + "img/check-circle-red.4ef0bc48.svg";